import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5aa78078&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=5aa78078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa78078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aa78078')) {
      api.createRecord('5aa78078', component.options)
    } else {
      api.reload('5aa78078', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5aa78078&scoped=true&", function () {
      api.rerender('5aa78078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deceased/detail.vue"
export default component.exports